import React, { useEffect, useRef } from 'react'
import { Animated, View } from 'react-native'
import { observer } from 'mobx-react-lite'
import { isInfoCard } from '@trivie/core/src/models/game/GameQuiz'

const AnimatedDot = (props: any) => {
  const { keyId, style, index } = props
  const dotFade = useRef(new Animated.Value(0)).current

  useEffect(() => {
    Animated.timing(dotFade, {
      toValue: 1.0,
      duration: 200,
      useNativeDriver: true,
      delay: index * 100,
    }).start()
  }, [dotFade])

  return <Animated.View key={keyId} style={[style, { opacity: dotFade }]} />
}

export const ProgressDots = observer((props: any) => {
  const { items, active, branding, style, mode = 'quiz' } = props
  const survey = mode === 'survey'
  return (
    <View style={{ gap: 16, flexDirection: 'row', justifyContent: 'center', ...style }}>
      {items?.map((item: any, index: number) => {
        // Surveys are ungraded, so completed dots use the accent color rather than
        // correct/incorrect coloring.
        const completedColor = survey
          ? branding.accent_color
          : item.answeredCorrectly
            ? branding.correct_answer
            : branding.incorrect_answer
        return (
          <AnimatedDot
            index={index}
            key={item.id.toString()}
            keyId={item.id.toString()}
            style={{
              borderRadius: 100,
              height: index === active ? 12 : 8,
              width: index === active ? 12 : 8,
              alignSelf: 'center',
              backgroundColor:
                index === active || isInfoCard(item)
                  ? branding.accent_color
                  : index > active
                    ? 'rgba(0, 120, 236, 0.24)'
                    : completedColor,
            }}
          />
        )
      })}
    </View>
  )
})
